import React from "react";
import AddIcon from '@mui/icons-material/Add';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { Link } from "react-router-dom"; //Link
 

const MedicineCard = ({ medicine }) => {
  return (
    <div className="main_outer_medicine_card">
       <Link to="/product">
           <div className="medicine-card">
            <button className="wishlist-btn">
              <FavoriteBorderIcon />
            </button>

            <div className="medicine-image">
              <img src={medicine.image} alt={medicine.name} />
            </div>

            <div className="medicine-content">
              <h3>{medicine.name}</h3>

              <p className="medicine-type">
                {medicine.category}
              </p>

              <div className="price-divider"></div>

              <div className="price-row">
                <div>
                  <span className="sale-price">
                    ₹{medicine.price}
                  </span>

                  <span className="old-price">
                    ₹{medicine.oldPrice}
                  </span>

                  <span className="discount">
                    {medicine.discount}
                  </span>
                </div>

                <button className="medicine-add-btn">
                  <AddIcon />
                </button>
              </div>
            </div>
          </div>
       </Link> 
    </div> 
  );
};

export default MedicineCard;